import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "news",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.NEWS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.NEWS.PERMISSIONS,
    },
    component: () => import("@/modules/News/views/news.vue"),
  },
];

export default routes;
